import React from "react";
import { Row, Col } from "reactstrap";

const Matching = ({ question, activeQuestionAnswer }) => {
  const targets = question.options?.filter((o) => o.type === "target") || [];
  const items = question.options?.filter((o) => o.type === "item") || [];
  const pairedAnswers = Array.isArray(activeQuestionAnswer?.answer)
    ? activeQuestionAnswer.answer
    : [];

  const renderCardContent = (option) => {
    if (!option) return null;
    if (option.image) {
      return (
        <img
          src={option.image}
          alt={option.text || ""}
          style={{
            maxHeight: "90px",
            maxWidth: "100%",
            borderRadius: "8px",
            objectFit: "contain",
          }}
        />
      );
    }
    return <span className="fw-bold text-dark fs-18">{option.text}</span>;
  };

  return (
    <div
      className="matching-columns-v2 mt-3 text-end"
      style={{ direction: "rtl" }}
    >
      {targets.map((target) => {
        const pairing = pairedAnswers.find((p) => p.targetId === target.id);
        const pairedItem = items.find((item) => item.id === pairing?.itemId);
        const isCorrectPair = pairedItem?.target === target.id;

        let borderColor = "#ebebeb";
        let bgColor = "#ffffff";
        let statusBadge = null;

        if (pairedItem) {
          if (isCorrectPair) {
            borderColor = "#2ec4b6";
            bgColor = "#f0fdf4";
          } else {
            borderColor = "#ff4d4d";
            bgColor = "#fef2f2";
          }
        }

        return (
          <div
            key={target.id}
            className="matching-row-item-v2 position-relative mb-4"
          >
            {statusBadge}
            <Row className="g-3 align-items-stretch">
              <Col xs={6}>
                <div
                  className="matching-card target-card-v2 d-flex align-items-center justify-content-center p-3 border rounded shadow-sm"
                  style={{
                    minHeight: "130px",
                    borderRadius: "16px",
                    backgroundColor: "#ffffff",
                    borderColor: borderColor,
                    borderWidth: pairedItem ? "2px" : "1px",
                  }}
                >
                  {renderCardContent(target)}
                </div>
              </Col>

              <Col xs={6}>
                <div
                  className="matching-card item-card-v2 d-flex align-items-center p-3 border rounded shadow-sm"
                  style={{
                    minHeight: "130px",
                    borderRadius: "16px",
                    backgroundColor: bgColor,
                    borderColor: borderColor,
                    borderWidth: pairedItem ? "2px" : "1px",
                  }}
                >
                  <div className="w-100 d-flex align-items-center justify-content-between">
                    <i
                      className="ri-draggable text-muted fs-20 me-2"
                      style={{ cursor: "grab" }}
                    ></i>
                    <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                      {pairedItem ? (
                        renderCardContent(pairedItem)
                      ) : (
                        <span className="text-muted small">لم يتم التوصيل</span>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        );
      })}
    </div>
  );
};

export default Matching;
